// ============================================================================
// shared/ui/Alert.tsx — Primitivo de alerta (reemplaza MUI <Stack><Alert/></Stack>).
// Tailwind + tokens; sin dependencias externas. Ver PLAN §B.3.
// Uso previo (MUI): <Stack spacing={2}><Alert variant="outlined" severity={sev}>{msg}</Alert></Stack>
// Uso nuevo:        <Alert severity={sev}>{msg}</Alert>
// ============================================================================
import type { ReactNode } from "react";

export type AlertSeverity = "success" | "warning" | "error" | "info";

const ESTILOS: Record<AlertSeverity, string> = {
  success: "tw-bg-green-50 tw-border-green-400 tw-text-green-800",
  warning: "tw-bg-yellow-50 tw-border-yellow-400 tw-text-yellow-800",
  error: "tw-bg-red-50 tw-border-red-400 tw-text-red-800",
  info: "tw-bg-blue-50 tw-border-blue-400 tw-text-blue-800",
};

interface AlertProps {
  /** Acepta string por compatibilidad con el estado `tipoAlerta: any` de las pages. */
  severity?: AlertSeverity | string;
  children?: ReactNode;
  className?: string;
}

export const Alert = ({ severity = "info", children, className = "" }: AlertProps) => {
  const estilo = ESTILOS[severity as AlertSeverity] ?? ESTILOS.info;
  return (
    <div role="alert" className={`tw-border tw-rounded tw-px-4 tw-py-3 tw-text-sm ${estilo} ${className}`}>
      {children}
    </div>
  );
};
